<template>
    <div class="ttt">
        <div class="nav-head" :style="getBgColor">
            <img v-if="bg" src="~assets/images/home/logo_03.png">
            <img v-if="!bg" src="~assets/images/product/logo_03.png">
            <img v-if="bg" is-link @click="showPopup" src="~assets/images/home/router.png">
            <img v-if="!bg" is-link @click="showPopup"  src="~assets/images/product/router.png">
        </div>
        <van-popup
                class="menu"
                v-model="show"
                position="right"
        >
            <div class="item"  v-for="item in router" :class="{activeLink:$route.path===item.to}">
                <router-link
                        :to="item.to"
                        v-if="!item.link"
                >

                    {{item.name}}
                    <span class="iconfont">&#xe623;</span>
                </router-link>
                <a v-else :href="item.link">{{item.name}} <span class="iconfont">&#xe623;</span></a>
            </div>
           </van-popup>

    </div>

</template>

<script>
    export default {
        name: "index",
        props: {
            bg:{
                type:Boolean,
                default(){
                    return true
                }
            }
        },
        data() {
          return {
              show:false,
              router:[
                  {page:'Home',to:'/',name:'首页'},
                  {page:'Product',to:'/product',name:'产品介绍'},
                  // {page:'JoinCase',to:'/joincase',name:'加盟案例'},
                  {page:'Serve',to:'',name:'服务市场',link:'../market'},
                  {page:'Industry',to:'/industry',name:'行业介绍'},
                  {page:'About',to:'/about',name:'关于联盟'},
                  {page:'Contact',to:'/contact',name:'联系我们'}
              ],
              route:'',
          }
        },
        mounted() {
            this.route = this.$route.name
            let arr = this.router.filter((val)=>{
                return val.page!=this.route
            })
        },
        methods: {
            showPopup() {
                this.show = true;
            }
        },
        computed: {
            getBgColor(){
                return {background:this.bg?'#126eac':'#fff'}
            },
            getRouter() {
                return  this.router.filter((val)=>{
                    return val.page!=this.route
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .ttt {
        /*position: sticky;*/
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        z-index: 10;
    }
    .nav-head {
        background: #126eac;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;

        img {
            &:first-child {
                height: 38px;

            }
            &:last-child {
                height: 25px;
            }
        }


    }
    .menu {
        height: 100%;
        width: 40%;
        padding-top: 40px;
        background: rgba(0,0,0,.7);
        color: #fff;
        z-index: 999;
        a {
            font-size: 30px;
            color: #fff;
            display: flex;
            padding: 20px;
            justify-content: space-between;
            align-items: center;
        }
        .activeLink {
            a {
                color: #5db8f2;
                pointer-events: none;
            }
        }
    }

</style>